<template>
  <div class="box">
    <div class="effect__tabs tabs">
      <div class="tabs__header">
        <div class="tabs__tab" v-for="(item, i) in tabArr" :key="i"
          @click="onClickTab(i)"
          :class="{'is-active': item.active}"
        >
          {{item.text}}
        </div>
        <div
          class="tabs__pointer"
          :class="{left: currTabTitle.name === 'in', right: currTabTitle.name === 'out'}"
        ></div>
      </div>
      <div class="tabs__content" v-bar> <!-- v-bar -->
        <div>
          <template v-for="(item, i) in tabArr">
            <div class="tabs__panel"
              v-show="item.active"
              :key="i"
            >
              <div class="flex">
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :disabled="!item.disabled"
                  v-for="(item, i) in mainItems"
                  :key="i"
                >
                <div slot="content" v-html="isDynamicArtText() ? tip2 : tip"></div>
                <div
                  class="effect__item"
                  :class="{['icon-wrapper-' + ( item.icon || getClassNamePart(item) )]: true, 'is-selected': item.selected, 'no-anim': item.type === 'None', disabled: item.disabled}"
                  @click="selectItem(item)"
                  :data-anim="item.type"
                  ref="effectBtnRef"
                >
                    <i
                      class="in-out-effect-icon"
                      :class="{[`icon-effect-${item.icon || getClassNamePart(item)}`]: true, 'is-out': currTabTitle.name && currTabTitle.name === 'out'}"
                      style="display: block"
                    ></i>
                  <span>{{item.text}}</span>
                </div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div
        class="tabs__footer"
        :class="{disabled: btnHand.disabled}"
        @click="
          showHandDialog($event);
          $analysis('animation_setting_panel,click_insert_hand,动画设置_添加手势')
        "
      >
        <i></i>
        <span>添加手势</span>
      </div>
    </div>

    <transition name="slide-up">
      <div class="child-effects effect-slide" v-show="childMode">
        <childEffects
          ref="childEffectsRef"
        ></childEffects>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import childEffects from './childEffects'

export default {
  components: {
    childEffects,
  },
  props: {
    sprite: {
      default () {
        return {}
      },
      type: Object
    }
  },
  data () {
    return {
      items: [
        {text: '无动画', type: 'None', disabled: false, alias: 'noAnim'},

        {text: '书写', type: 'Write', disabled: false, alias: 'write'},
        {text: '逐行显示', type: 'Appear', disabled: false, alias: 'appear'},
        {text: '打字', type: 'Type', disabled: false, alias: 'type'},
        {text: '翻滚', type: 'Roll', disabled: false, alias: 'roll'},
        {text: '弹跳', type: 'Bounce', disabled: false, alias: 'bounce'},

        {text: '手绘', type: 'Hand', disabled: false, alias: 'hand'},
        {text: '涂抹', type: 'Draw', disabled: false, alias: 'write'},

        {text: '移入', type: 'Slide', disabled: false, alias: 'slide'},
        {text: '放大出现', type: 'PopIn', disabled: false, alias: 'pop'},
        {text: '淡入', type: 'FadeIn', disabled: false, alias: 'fade'},
        {text: '擦入', type: 'Smear', disabled: false, alias: 'smear'},
      ],
      outItems: [
        {text: '无动画', type: 'None', disabled: false, alias: 'noAnim'},
        {text: '移出', type: 'Slide', disabled: false, alias: 'slide'},
        {text: '缩小退出', type: 'PopOut', disabled: false, alias: 'pop'},
        {text: '淡出', type: 'FadeOut', disabled: false, alias: 'fade'},
        {text: '擦出', type: 'Smear', disabled: false, alias: 'smear'},
      ],
      inEffects: {
        common: [
          'None',
          'Slide',
          'LeftIn',
          'RightIn',
          'DownIn',
          'UpIn',
          'PopIn',
          'FadeIn',
          'Smear'
        ],
        text: [
          'Write',
          'Appear',
          'Type',
          'Roll',
          'Bounce'
        ],
        svg: [
          'Hand',
          'Draw'
        ],
        image: [
          'Draw'
        ],
        slide: [
          'LeftIn',
          'RightIn',
          'DownIn',
          'UpIn',
        ],
        special: [
          'Write',
          'Appear',
          'Type',
          'Roll',
          'Bounce',
          'Hand',
          'Draw'
        ]
      },
      outEffects: {
        common: [
          'None',
          'RightOut',
          'LeftOut',
          'UpOut',
          'DownOut',
          'PopOut',
          'FadeOut',
          'Smear'
        ],
        slide: [
          'RightOut',
          'LeftOut',
          'UpOut',
          'DownOut',
        ]
      },
      canHand: [
        'Slide', 'Hand', 'Draw', 'Write',
        'LeftIn',
        'RightIn',
        'DownIn',
        'UpIn',
        'RightOut',
        'LeftOut',
        'UpOut',
        'DownOut',
      ],
      tabArr: [
        {active: true, text: '入场', name: 'in'},
        {active: false, text: '出场', name: 'out'},
      ],
      childMode: false,
      btnHand: {
        disabled: true
      },
      tip: '该入场与停留特效不能并存，<br/>请调整试试吧',
      tip2: '该入场与动态艺术字不能并存，<br/>请调整试试吧',
      reports: {
        'None': 'animation_setting_panel,click_ee_ffect_None,动画设置_出入场动画_无动画',
        'Write': 'animation_setting_panel,click_ee_ffect_Write,动画设置_出入场动画_书写',
        'Appear': 'animation_setting_panel,click_ee_ffect_Appear,动画设置_出入场动画_逐行显示',
        'Type': 'animation_setting_panel,click_ee_ffect_Type,动画设置_出入场动画_打字',
        'Roll': 'animation_setting_panel,click_ee_ffect_Roll,动画设置_出入场动画_翻滚',
        'Bounce': 'animation_setting_panel,click_ee_ffect_Bounce,动画设置_出入场动画_弹跳',
        'Hand': 'animation_setting_panel,click_ee_ffect_Hand,动画设置_出入场动画_手绘',
        'Draw': 'animation_setting_panel,click_ee_ffect_Draw,动画设置_出入场动画_涂抹',
        'Slide': 'animation_setting_panel,click_ee_ffect_Slide,动画设置_出入场动画_移入',
        'PopIn': 'animation_setting_panel,click_ee_ffect_PopIn,动画设置_出入场动画_放大出现',
        'FadeIn': 'animation_setting_panel,click_ee_ffect_effectName,动画设置_出入场动画_淡入',
        'Smear': 'animation_setting_panel,click_ee_ffect_Smear,动画设置_出入场动画_擦入',
        'PopOut': 'animation_setting_panel,click_ee_ffect_PopOut,动画设置_出入场动画_缩小退出',
        'FadeOut': 'animation_setting_panel,click_ee_ffect_FadeOut,动画设置_出入场动画_淡出',
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteBeforeSwap'
    ]),
    ...mapGetters({
      storeHand: 'getHand'
    }),
    filteredItems () {
      if (this.sprite.type === 'Text') {
        return this.items.filter(v => {
          return this.inEffects.common.indexOf(v.type) > -1 || this.inEffects.text.indexOf(v.type) > -1;
        })
      }

      if (this.sprite.type === 'Svg' || this.sprite.type === 'Image') {
        return this.items.filter(v => {
          return this.inEffects.common.indexOf(v.type) > -1 || this.inEffects[this.sprite.type.toLowerCase()].indexOf(v.type) > -1;
        })
      }

      return this.items.filter(v => {
        return this.inEffects.common.indexOf(v.type) > -1;
      })
    },
    currTabTitle () {
      return this.tabArr.filter(item => item.active)[0];
    },
    mainItems () {
      let activeTab = (this.tabArr.filter(v => v.active) || [])[0];
      if (activeTab.name === 'in') {
        return this.filteredItems;
      }
      if (activeTab.name === 'out') {
        return this.outItems;
      }
      return {}
    }
  },
  watch: {
    childMode: {
      handler (val) {
        this.$emit('childModeUpdated', val);
      }
    },
    currTabTitle: {
      handler (val) {
        let inOut = val.name;
        this.$refs.childEffectsRef.showList({
          inOut,
        });
        this.render();
      }
    }
  },
  created () {
    this.$bus.on('childEffects.optionChanged', () => {
      this.render();
    })
  },
  mounted () {
    if (!this.sprite) {
      return;
    }
    this.render();
  },
  methods: {
    render () {
      let effect = this.sprite.effect;
      let inType = effect.type || effect.code;
      let outType = effect.exitAnim.type;

      for (let v of this.items) {
        this.$set(v, 'selected', v.type === inType);
      }
      if (this.inEffects.slide.indexOf(inType) > -1) {
        this.$set(this.items.filter(item => item.type === 'Slide')[0], 'selected', true);
      }

      for (let v of this.outItems) {
        this.$set(v, 'selected', v.type === outType);
      }
      if (this.outEffects.slide.indexOf(outType) > -1) {
        this.$set(this.outItems.filter(item => item.type === 'Slide')[0], 'selected', true);
      }

      this.renderDisabled();

      if (this.currTabTitle.name === 'in') {
        this.btnHand.disabled = this.canHand.indexOf(inType) < 0;
      }

      if (this.currTabTitle.name === 'out') {
        this.btnHand.disabled = this.canHand.indexOf(outType) < 0;
      }

    },
    onClickTab (index) {
      for (let [i, v] of this.tabArr.entries()) {
        this.$set(v, 'active', index === i);
      }
    },
    selectItem (item) {
      if (item.disabled) {
        return;
      }
      this.$analysis(this.reports[item.type]);

      if (/^(Slide|Smear)$/.test(item.type)) {
        this.toggleChildMode(true, item);
        return;
      }

      this.setEffect(item);
    },
    toggleChildMode (flag, item) {
      this.childMode = flag;
      if (flag) {
        let inOut = this.currTabTitle.name;
        let animation = item.type.toLowerCase() || 'slide';
        this.$refs.childEffectsRef.showList({
          inOut,
          animation
        });
      }
    },
    setEffect (item) {
      let inOut = this.currTabTitle.name;
      let sprite = this.sprite;
      let inOutType;
      if (inOut === 'in') {
        let {start, end} = sprite.effect.entranceAnim;
        let handInfo = (item.type === 'Hand' || item.type === 'Draw')
          ? this.storeHand
          : null;
        if (item.type === 'None') {
          start = end;
        } else {
          start = Math.max(end - 500, 0);
        }
        this.sprite.updateEffect({
          code: item.type,
          entranceAnim: {
            start,
            end,
            hand: handInfo
          }
        }, true);

        inOutType = 'entrance';
      }
      if (inOut === 'out') {
        let {start, end} = sprite.effect.exitAnim;
        if (item.type === 'None') {
          end = start;
        } else {
          if(start >= this.TOOL.selectedScenes.duration) {
            start = this.TOOL.selectedScenes.duration - 500;
          }
          end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
        }
        this.sprite.updateEffect({
          exitAnim: {
            type: item.type,
            start,
            end
          }
        }, true);

        inOutType = 'exit';
      }

      this.sprite.effect.init();
      this.$bus.emit('updateEffect_vue', {
        sprite: this.sprite,
        effect: this.sprite.effect || {},
        type: inOutType
      });

      this.render();
    },
    getClassNamePart (item) {
      let type = item.type;
      let inOut = this.currTabTitle.name;
      let isOut = inOut === 'out';
      let effectType = isOut
        ? this.sprite.effect.exitAnim.type
        : (this.sprite.effect.type || this.sprite.effect.code);
      if (type === 'Slide') {
        let map = {
          LeftIn: 'right',
          RightIn: 'left',
          UpIn: 'down',
          DownIn: 'up',
          LeftOut: 'left',
          RightOut: 'right',
          UpOut: 'up',
          DownOut: 'down'
        };
        return map[effectType] || 'left';
      }
      if (type === 'Smear') {
        return 'smear-n';
      }

      return item.alias;
    },

    showHandDialog (ev) {
      if (ev.currentTarget.classList.contains('disabled')) {
        return;
      }

      // 入场是否书写动画
      let modalName = this.sprite.effect.code === 'Write' ? 'writehand' : 'hand';

      this.$bus.emit('Modal_vue', {
        name: modalName,
        type: modalName,
        data: {
          inout: this.currTabTitle.name,
        }
      });
    },

    hasPathOrStay () {
      return this.sprite.effect.pathAnim.target || this.sprite.effect.stayAnim.type !== 'None'
    },

    isDynamicArtText () {
      let sprite = this.sprite || {};
      return sprite.type === 'Text' && sprite.artType && sprite.artControl && sprite.artControl.length
    },

    renderDisabled () {
      let shouldDisabled = this.hasPathOrStay() || this.isDynamicArtText();
      let names = this.inEffects.special;
      let filtered = this.items.filter(item => names.indexOf(item.type) > -1) || [];
      filtered.map(item => {
        this.$set(item, 'disabled', shouldDisabled);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors";
@import '../../../style/_triangle.scss';

.box {
  position: relative;
}

.effect {
  padding-left: 20px;
  padding-right: 20px;
  color: #474261;
  &__item {
    display: inline-block;
    margin-top: 16px;
    margin-right: 18px;
    text-align: center;
    cursor: pointer;

    &:nth-of-type(3n) {
      margin-right: 0;
    }
    &:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3) {
      margin-top: 0;
    }

    > .in-out-effect-icon {
      display: block;
      width: 60px;
      height: 58px;
      border: 1px solid #eff1f8;
      border-radius: 4px;
      background-color: #eff1f8;
      &.is-short {
        height: 50px;
      }
      &.is-disabled {
        opacity: 0.3;
        // background-color: red;
      }
    }
    > span {
      display: block;
      margin-top: 6px;
    }

    &.is-selected {
      > i {
        border: 1px solid $c2;
        box-shadow: 0 0 0 0.5px #5779fa;
      }
    }

    &.no-anim {
      > i {
        position: relative;
        overflow: hidden;
        &:before {
          content: " ";
          position: absolute;
          height: 1px;
          width: 110px;
          background-color: red;
          transform: rotate(-45deg) translatex(-60px) translatey(-19px);
        }
      }
    }

    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  &__item--top {
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 58px;
      background: #eff1f8;
      border-radius: 4px;
    }

    &.is-selected {
      & > div {
        border: 1.5px #5779fa solid;
      }
    }
  }

  &__top {
    margin-top: 34px;
    text-align: left;
    > span {
      display: block;
    }
  }

  &__main {
    position: relative;
    margin-top: 33px;
    text-align: left;

  }

  &__tabs {
    position: relative;
  }

  &__content {
    height: 270px;
    overflow: auto;
  }
}

.tabs {
  position: relative;

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__tab {
    display: inline-block;
    width: 130px;
    height: 34px;
    background-color: #f8f8fc;
    line-height: 34px;
    text-align: center;
    cursor: default;

    &.is-active {
      color: #fff;
      background-color: #5778fb;
    }
  }
  &__pointer {
    position: absolute;
    bottom: 0;
    transition-duration: 0.3s;
    transform: translatex(-50%);
    @include triangle(top, 6px, 4px, rgba(#fff, 1));

    &.left {
      left: 25%;
    }
    &.right {
      left: 75%;
    }
  }

  &__content {
    // position: absolute;
    // top: 20px;
    // left: -20px;
    width: 258px;
    height: 226px;
    padding-left: 20px;
  }
  &__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 258px;
    height: 36px;
    background-color: #f0f0f8;
    cursor: pointer;

    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  &__panel {
    // position: absolute;
    // top: 0;
    // left: 20px;
    display: inline-block;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 20px;
    >.flex {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
}

.child-effects {
  position: absolute;
  left: 0;
  top: 34px;
  width: 100%;
  height: 226px;
  background-color: #fff;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition-duration: 0.3s;
  position: absolute;
}
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(300px);
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/effectSetting/boxTwo.vue